// badWordsList.js
const BAD_WORDS = [
  "anal",
  "anus",
  "arse",
  "ass",
  "asshole",
  "ballsack",
  "balls",
  "bastard",
  "bitch",
  "biatch",
  "bloody",
  "blowjob",
  "bollock",
  "bollok",
  "boner",
  "boob",
  "boobs",
  "bugger",
  "bum",
  "butt",
  "buttplug",
  "clit",
  "cock",
  "coon",
  "crap",
  "cum",
  "cunt",
  "damn",
  "dick",
  "dildo",
  "dyke",
  "fag",
  "faggot",
  "fatass",
  "fellate",
  "fellatio",
  "felching",
  "fuck",
  "fucker",
  "fucking",
  "fudgepacker",
  "fudge packer",
  "gay",
  "goddamn",
  "god damn",
  "homo",
  "jerk",
  "jizz",
  "knobend",
  "knob end",
  "labia",
  "lust",
  "masturbate",
  "masturbation",
  "muff",
  "nigga",
  "nigger",
  "nipple",
  "nips",
  "penis",
  "piss",
  "poop",
  "porn",
  "prick",
  "pube",
  "pussy",
  "queer",
  "rape",
  "rapist",
  "rectum",
  "retard",
  "rimjob",
  "sadist",
  "schlong",
  "scrote",
  "scrotum",
  "sex",
  "shit",
  "shitass",
  "shitbag",
  "shithead",
  "shitty",
  "slut",
  "smegma",
  "spunk",
  "tard",
  "testicle",
  "tit",
  "titties",
  "titty",
  "twat",
  "vagina",
  "wank",
  "whore",
  "wiener",
  "willy",
  "wtf",
  "xxx",
  "sexballs",
  "assclown",
  "cockhead",
  "cockface",
  "balllicker",
  "turd",
  "anusface",
  "fuckface",
  "motherfucker",
  "cocksucker",
  "twatwaffle",
  "shitlord",
  "shart",
  "dickweed",
  "nutsack",
  "nutlicker",
  "bastardo",
  "shitfaced",
  "bitchass",
  "bitchface",
  "fucknugget",
  "douche",
  "douchebag",
  "fuckwit",
  "shithead",
  "dickbag",
  "titfuck",
  "asslicker",
  "suckmydick",
  "lickmyass",
  "fuckyourmom",
  "dicknose",
  "buttface",
  "ballsdeep",
  "deepthroat",
  "jerkoff",
  "peehole",
  "cockholster",
  "gobshite",
];

const leetMap = {
  0: "o",
  1: "i",
  "!": "i",
  3: "e",
  4: "a",
  "@": "a",
  5: "s",
  $: "s",
  7: "t",
  8: "b",
  9: "g",
};

const normalizeLeetspeak = (str) => {
  return str
    .toLowerCase()
    .replace(/\s+/g, "") // remove spaces
    .split("")
    .map((char) => leetMap[char] || char)
    .join("");
};

export const containsProfanity = (input) => {
  const cleaned = normalizeLeetspeak(input);
  return BAD_WORDS.some((word) => cleaned.includes(word));
};
